import {
  QIcon_caf_accuracy,
  QIcon_caf_complexity,
  QIcon_caf_fluency,
  QIcon_caf_lessons_secondary,
  QIcon_caf_list,
  QIcon_caf_overview,
  QIcon_caf_pronunciation,
} from '@repo/icons/index'
import { n_caf, s_caf } from '../i18n/strings/auto/wording_webview'
import { COLORS } from '../vars'

export const CAF_LEVEL_MAX = 10
export const GRAPH_TOOLTIP_CLS = 'rounded-[5px] border shadow bg-white px-[8px] py-[4px] text-[12px]'
export const BOX_BORDER_CLX = 'border rounded-[6px] border-1 border-gray-100'
export const DESCRIPTION_CLX = 'text-sBody '
export const GRAPH_LABEL_TEXT_COLOR = 'rgba(171, 188, 213, 1)'
export const PAGE_WRAPPER_STYLE = 'bg-white pt-[16px] text-gray-700 break-words pb-[40px] min-h-screen keep-all'
export const SECTION_WRAPPER_STYLE = 'px-[20px]'

export const HIGH_ACTIVE_CHART_COLOR = 'rgba(255, 48, 81, 1)'
export const HIGH_INACTIVE_CHART_COLOR = 'rgba(255, 48, 81, 0.3)'
export const ACTIVE_CHART_COLOR = 'rgba(63, 61, 136, 1)'
export const INACTIVE_CHART_COLOR = 'rgba(63, 61, 136, 0.3)'
export const BAR_ITEM_WIDTH = 28
export const graph_common_props = {
  grid: {
    line: {
      strokeDasharray: '1',
      stroke: COLORS.GRAY200,
    },
  },
  axis: {
    domain: {
      line: {
        strokeDasharray: '1',
        stroke: COLORS.GRAY200,
      },
    },
  },
}
export const chartWidth =
  typeof window !== 'undefined' ? (window?.screen?.width < 640 ? window.screen.width - 32 - 40 : 620) : 0

export const app_api_result_postmsg = {
  report: {
    success: 'report_success',
    fail: 'report_fail',
  },
}

export const LEGACY_WEB_CAF_OVERVIEW_SIDE_MENU = [
  {
    icon: (color: string) => (
      <QIcon_caf_overview color={COLORS.PURPLE500} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_overview,
    name: 'overview',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_complexity color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_complexity,
    name: 'complexity',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_accuracy color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_accuracy,
    name: 'accuracy',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_fluency color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_fluency,
    name: 'fluency',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_list color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_areas,
    name: 'focusareas',
  },
]
export const WEB_CAF_OVERVIEW_SIDE_MENU = [
  {
    icon: (color: string) => (
      <QIcon_caf_overview color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_overview,
    name: 'overview',
    tag: 999,
    tab: 0,
  },
  {
    icon: (color: string) => (
      <QIcon_caf_complexity color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_complexity,
    name: 'complexity',
    tag: 1,
    tab: 1,
  },
  {
    icon: (color: string) => (
      <QIcon_caf_accuracy color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_accuracy,
    name: 'accuracy',
    tag: 2,
    tab: 2,
  },
  {
    icon: (color: string) => (
      <QIcon_caf_fluency color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_fluency,
    name: 'fluency',
    tag: 3,
    tab: 3,
  },
  {
    icon: (color: string) => (
      <QIcon_caf_pronunciation color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: n_caf.overview.menu_pronunciation,
    name: 'pronunciation',
    tag: 4,
    tab: 4,
  },
  {
    icon: (color: string) => (
      <QIcon_caf_list color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_areas,
    name: 'focusareas',
    tag: 999,
    tab: 5,
  },
]
export const WEB_CAF_STATISTICS_SIDE_MENU = [
  {
    icon: (color: string) => (
      <QIcon_caf_overview color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: n_caf.statistic.menu_statistics,
    name: 'overview',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_lessons_secondary
        color={color}
        fill={color}
        className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current"
      />
    ),
    label: n_caf.statistic.lessons,
    name: 'lessons',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_list color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: n_caf.overview.menu_areas,
    name: 'focusareas',
  },
]
export const WEB_CAF_STATISTICS_SIDE_MENU_LEGACY = [
  {
    icon: (color: string) => (
      <QIcon_caf_overview color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.statistic.menu_statistics,
    name: 'overview',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_lessons_secondary
        color={color}
        fill={color}
        className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current"
      />
    ),
    label: s_caf.statistic.lessons,
    name: 'lessons',
  },
  {
    icon: (color: string) => (
      <QIcon_caf_list color={color} fill={color} className="mr-[4px] h-[24px] w-[24px] [&>*]:fill-current" />
    ),
    label: s_caf.overview.menu_areas,
    name: 'focusareas',
  },
]
